/** 售后 Support Ticket 菜单（990320+；勿与 990310 车载 canAutoMatch 冲突） */
export const SUPPORT_TICKET_MENU_IDS = {
  group: 990320,
  create: 990321,
  mine: 990322,
  workbench: 990323,
  reply: 990324,
  playbook: 990325
}

export const SUPPORT_TICKET_DOMAIN = {
  HARDWARE: 'HARDWARE',
  SOFTWARE: 'SOFTWARE'
}

export const SUPPORT_TICKET_EQUIPMENT_NA = 'SOFTWARE-N/A'

export const SUPPORT_TICKET_AUTHOR_LABEL = {
  CUSTOMER: '客户',
  STAFF: '售后',
  SYSTEM: '系统'
}

export const SUPPORT_TICKET_REPLY_TYPE_LABEL = {
  OPENING: '开单',
  CUSTOMER_REPLY: '客户追问',
  TECH_REPLY: '技术回复',
  ASK_CUSTOMER: '待您补充',
  RESOLVE: '已解决',
  INTERNAL_NOTE: '内部备注'
}

export const SUPPORT_TICKET_STATUS_LABEL = {
  OPEN: '待受理',
  IN_PROGRESS: '处理中',
  WAITING_CUSTOMER: '待您补充',
  RESOLVED: '已解决',
  CLOSED: '已结案',
  CANCELLED: '已取消'
}

/** 与 coffee_menu.perms 一致（SSOT 见 supportTicketPermissions.js） */
export const SUPPORT_TICKET_PERM = {
  CREATE: 'support:ticket:create',
  VIEW_OWN: 'support:ticket:view:own',
  MANAGE: 'support:ticket:manage',
  REPLY: 'support:ticket:reply',
  PLAYBOOK_MANAGE: 'support:playbook:manage'
}

/** 用户使用说明书（leo-web /support） */
export const SUPPORT_TICKET_USER_GUIDE_URL = (() => {
  const base = (process.env.VITE_LEO_WEB_BASE || 'https://leo.xrross-soc.com').replace(/\/$/, '')
  return `${base}/support`
})()



// WEBPACK FOOTER //
// ./src/constants/supportTicket.js